import type { ShibaExpression } from "@/stores/coachStore";

export interface ShibaTeacherProps {
  expression?: ShibaExpression;
  size?: number;
  className?: string;
  ariaLabel?: string;
}

export function ShibaTeacher({
  size = 120,
  className,
  ariaLabel = "小柴老师",
}: ShibaTeacherProps) {
  return (
    <img
      src="/shiba/shiba_teacher.png"
      width={size}
      height={size}
      alt={ariaLabel}
      className={`rounded-full object-cover${className ? ` ${className}` : ""}`}
      decoding="async"
      loading="lazy"
    />
  );
}
